<template>
  <PriceRescueConfirmationDialog
    v-if="confirmation.pending"
    body-class="pr-modal-body"
    cancel-button-class="pr-btn"
    consequence-class="pr-confirmation-consequence"
    danger-confirm-button-class="pr-btn pr-btn-danger"
    dialog-class="pr-modal pr-modal-sm pr-confirmation-dialog"
    field-class="pr-field"
    financial-confirm-button-class="pr-btn pr-btn-primary"
    footer-class="pr-modal-foot"
    header-class="pr-modal-head"
    input-class="pr-input"
    overlay-class="pr-modal-overlay pr-confirmation-overlay"
    :cancel-label="confirmation.pending.cancelLabel"
    :confirm-label="confirmation.pending.confirmLabel"
    :consequence="confirmation.pending.consequence"
    :message="confirmation.pending.message"
    :open="confirmation.pending !== null"
    :require-typed-text="confirmation.pending.requireTypedText"
    :title="confirmation.pending.title"
    :tone="confirmation.pending.tone"
    @cancel="confirmation.cancel()"
    @confirm="confirmation.accept()"
  />
</template>

<script setup lang="ts">
import { PriceRescueConfirmationDialog } from "@price-rescue/ui-components";

import { useMerchantConfirmationStore } from "../../features/shared-ui/confirmation-store.js";

const confirmation = useMerchantConfirmationStore();
</script>
